var map = {
	"./A. Harinath.jpeg": 338,
	"./Anjineyulu.jpeg": 178,
	"./B. Ramesh Naik.jpeg": 701,
	"./C. Balakrishna.jpeg": 869,
	"./D. Chandrasekhar.jpeg": 995,
	"./D.V. Prahallada.jpeg": 948,
	"./G. Ganesh.jpeg": 361,
	"./G. Raghavendra Reddy.jpeg": 962,
	"./K. Somusekhar.jpeg": 627,
	"./K. Vineetha.jpeg": 385,
	"./P. Chandrasekhar.jpeg": 439,
	"./P. Maeen Basha.jpeg": 357,
	"./P. Pramod.jpeg": 241,
	"./R. Venkata Reddy.jpeg": 569,
	"./S. Manohar Reddy.jpeg": 813,
	"./S. Thasleem.jpeg": 46,
	"./T. Ramanjineyulu.jpeg": 332
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 384;